<!--
 * @FilePath: /daren-html-source/src/views/Help/expand.vue
 * @Description: 引荐计划tab
-->
<template>
  <div class="rebate">
    <!-- 什么是引荐计划？ -->
    <div class="oneBox">
      <div class="titleBox">
        <span class="title">{{ $t('exPand.exTextOne') }}</span>
        <span class="content">{{ $t('exPand.exTextTwo') }}</span>
      </div>
      <div class="imgBox">
        <img
          :class="{
            bgImg: true,
            bgImgEn: lang == 'en',
          }"
          :src="$utils.getPng(icon1)"
          alt=""
        />
      </div>
    </div>
    <div class="Title">{{ $t('help.rebate.MasterRating') }}</div>
    <LevelTabe></LevelTabe>
    <!-- 规则说明 -->
    <div class="fourBox">
      <div class="bigTitle">{{ $t('exPand.Rules') }}</div>
      <!-- 奖励规则 -->
      <div class="contentOne">
        <div class="smallTitle">{{ ruleList.rule_1_title }}</div>
        <div class="one" v-for="(item, index) in ruleList.rule_1" :key="index">
          <span class="three">{{ index + 1 }}.&nbsp;</span>
          <span class="rightC">
            <span class="three">{{ item.bold_text }}</span>
            {{ item.text.replace(item.bold_text, '') }}
            <span class="two" v-if="item.gray_font_text != ''">{{
              item.gray_font_text
            }}</span></span
          >
        </div>
      </div>
      <!-- 判定细则 -->
      <div class="contentOne">
        <div class="smallTitle">{{ ruleList.rule_2_title }}</div>
        <div v-for="(item, index) in ruleList.rule_2" :key="index">
          <div class="one three">
            {{ item.title }}
          </div>
          <div class="one" v-for="(itm, idx) in item.child" :key="idx">
            &nbsp;&nbsp;&nbsp;&nbsp;{{ itm.i }}.&nbsp;<span class="rightC">{{
              itm.v
            }}</span>
          </div>
        </div>
      </div>
      <!-- 其他说明 -->
      <div class="contentOne" style="margin-bottom: 0">
        <div class="smallTitle">{{ ruleList.rule_3_title }}</div>
        <div class="one" v-for="(item, index) in ruleList.rule_3" :key="index">
          {{ item }}
        </div>
      </div>
    </div>
    <!-- <div class="pub-tit0">{{ $t('help.rebate.TextOne') }}</div>
    <div class="intrBox">
      <div class="one">{{ $t('help.rebate.TextTwo') }}</div>
      <div class="one">
        {{ $t('help.rebate.TextThree') }}
      </div>

    </div>
    <div class="pub-tit0" style="margin: 40px 0 20px 0">{{ $t('help.rebate.MasterRating') }}</div>
    <LevelTabe></LevelTabe> -->
  </div>
</template>

<script>
import LevelTabe from '@/components/LevelTable/index.vue'
import { getRule } from '@/utils/apiList/exPand'
export default {
  components: {
    LevelTabe,
  },
  data() {
    return {
      icon1: '',
      lang: '',
      ruleList: {},
    }
  },
  watch: {
    lang() {
      if (this.lang == 'en') {
        this.icon1 = 'referral-one1-en'
      } else if (this.lang == 'zhhk') {
        this.icon1 = 'referral-one1-hk'
      } else {
        this.icon1 = 'referral-one1'
      }
    },
  },
  mounted() {
    this.lang = localStorage.getItem('lang') ?? 'zh'
    this.getRuleList()
  },
  methods: {
    //获取奖励规则
    getRuleList() {
      getRule()
        .then(res => {
          this.ruleList = res.data
        })
        .catch(err => {})
    },
  },
}
</script>

<style lang="scss" scoped>
.rebate {
  padding-bottom: 48px;
  .oneBox {
    margin-bottom: 40px;
    .titleBox {
      display: flex;
      flex-direction: column;
      .title {
        font-weight: 600;
        font-size: 18px;
        color: #2c2c2c;
        line-height: 24px;
        margin-bottom: 4px;
      }
      .content {
        font-weight: 400;
        font-size: 12px;
        color: #8a8b92;
        line-height: 20px;
      }
    }
    .imgBox {
      padding-left: 30px;
      margin-top: 24px;
      .bgImg {
        width: 836px;
        object-fit: cover;
      }
      .bgImgEn {
        width: 868px !important;
        object-fit: cover;
      }
    }
  }
  .Title {
    font-weight: 600;
    font-size: 18px;
    color: #2c2c2c;
    line-height: 24px;
    margin-bottom: 20px;
  }
  .fourBox {
    margin-top: 40px;
    .bigTitle {
      font-weight: 600;
      font-size: 18px;
      color: #2c2c2c;
      line-height: 26px;
      margin-bottom: 12px;
    }
    .contentOne {
      display: flex;
      margin-bottom: 24px;
      flex-direction: column;
      align-items: flex-start;
      .smallTitle {
        font-weight: 600;
        font-size: 14px;
        color: #2c2c2c;
        line-height: 22px;
        margin-bottom: 5px;
      }
      .one {
        font-size: 12px;
        color: #2c2c2c;
        line-height: 26px;
        display: flex;
        align-items: flex-start;
        // letter-spacing: 1px;
        .rightC {
          text-align: left;
        }
      }
      .two {
        color: #8a8b92 !important;
      }
      .three {
        font-weight: 600;
      }
    }
  }
}
</style>
